import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  height: 500px;
  overflow: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const ContainerWrapper = styled.div``;
